import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('WIDGET', {
  FETCH_ITEM_REQUEST: null,
  FETCH_ITEM_FAILURE: null,
  FETCH_ITEM_SUCCESS: null
});



// WEBPACK FOOTER //
// ./app/constants/WidgetConstants.js